import { createContext, useContext, useReducer } from 'react'
import { initialState, reducer } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'

TreeDataContext = createContext()

export TreeDataProvider = ({ children }) ->
  
  isMounted = useComponentIsMountedRef()
  [state, dispatch] = useReducer(reducer, initialState)

  protectedDispatch = (args...) ->
    return unless isMounted.current
    dispatch(args...)
  
  <TreeDataContext.Provider value={[state, protectedDispatch]}>
    { children }
  </TreeDataContext.Provider>

export useTreeData = () -> 
  useContext(TreeDataContext)
  